<!--  -->
<template>
  <div class="app" v-if="Reward" @mousewheel.prevent>
    <div class="model-reward" v-if="showReward">
      <div class="model-reward-bg"></div>
      <div class="model-reward-body">
        <div class="body-top">
          <div>羁绊币：0</div>
          <div>充值</div>
        </div>
        <ul class="body-content">
          <li v-for="(item, index) in reward" :key="index">
            <div class="body-content-left">
              <span>{{item.money}}</span>
              <span>{{item.title}}</span>
            </div>
            <input
              class="radio_type"
              type="radio"
              name="type"
              id="index"
              @click="getrewardIndex(index)"
            />
            <label for="radio1"></label>
          </li>
          <div class="line"></div>
        </ul>
        <div class="body-bottom">
          <div @click="close">放弃打赏</div>
          <div @click="dialog">确认打赏</div>
        </div>
      </div>
    </div>
    <div v-if="dialogVisible" class="dialog">
      <div class="dialog-bg"></div>
      <div class="dialog-content">
        <p>打赏成功</p>
        <p>打赏金额将全部归作者所有</p>
        <span slot="footer" class="dialog-footer">
          <div type="primary" @click="closedialog" class="dialog-btn">确 定</div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  props: ["Reward", "bookReward", "adminReward"],
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      showReward: true,
      reward: "",
      rewardIndex: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    close() {
      this.$parent.reward();
    },
    dialog() {
      this.showReward = false;
      if (this.$cookies.isKey("token") && this.rewardIndex) {
        if (this.bookReward) {
          this.bookReward.token = this.$cookies.get("token");
          this.bookReward.reader = this.reward[this.rewardIndex].money;
          this.$http.post("reward/paintReward/", this.bookReward).then(res => {
            this.dialogVisible = true;
          });
        } else if (this.adminReward) {
          this.adminReward.token = this.$cookies.get("token");
          this.adminReward.money = this.reward[this.rewardIndex].money;
          this.$http.post("reward/adminReward/", this.adminReward).then(res => {
            this.dialogVisible = true;
            console.log("adminReward", res);
          });
        }
      } else {
        alert("未登入");
      }
    },
    closedialog() {
      this.showReward = true;
      this.dialogVisible = false;
      this.$parent.reward();
    },
    getrewardIndex(rewardIndex) {
      this.rewardIndex = rewardIndex;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {
    this.$http
      .post("reward/show/", { token: this.$cookies.get("token") })
      .then(res => {
        this.reward = res.body.data;
      });
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.model-reward {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 101;
  justify-content: center;
  align-items: center;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 16px;
}

.model-reward-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.3;
  z-index: 102;
}

.model-reward-body {
  height: 420px;
  width: 270px;
  background-color: #ffffff;
  z-index: 102;
  border-radius: 16px;
}

ul > li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px;
  height: 64px;
}

.body-top {
  border-radius: 16px 16px 0 0;
  height: 80px;
  background-color: #404040;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 18px;
}

.body-top div:nth-child(2) {
  color: #51d3e2;
}

.body-content-left {
  display: flex;
  flex-direction: column;
}

.body-content-left span {
  color: #28a3b1;
  font-size: 18px;
}

.body-content-left span:nth-child(2) {
  color: #808080;
  font-size: 14px;
}

.line {
  height: 1px;
  margin: 0 16px;
  background-color: #cccccc;
}

.body-bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 80px;
}

.body-bottom div:nth-child(1) {
  color: #808080;
  font-size: 16px;
  cursor: pointer;
}

.body-bottom div:nth-child(2) {
  color: #212121;
  font-size: 16px;
  font-weight: bold;
  font-family: MicrosoftYaHei-Bold;
  cursor: pointer;
}

label {
  line-height: 20px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 15px;
  color: #777;
  position: absolute;
}

.radio_type {
  width: 20px;
  height: 20px;
  appearance: none;
}

.radio_type:before {
  content: "";
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  border: 2px solid #b3b3b3;
  border-radius: 4px;
}

.radio_type:checked:before {
  content: "";
  width: 20px;
  height: 20px;
  border: 2px solid #b3b3b3;
  background-image: url(../img/check.png);
  display: inline-block;
  vertical-align: middle;
  background-size: 100% 100%;
}

.radio_type:checked:after {
  content: "";
  width: 10px;
  height: 5px;
  border: 2px solid white;
  border-top: transparent;
  border-right: transparent;
  text-align: center;
  display: block;
  position: absolute;
  top: 6px;
  left: 5px;
  transform: rotate(-45deg);
}

.radio_type:checked + label {
  color: #b3b3b3;
}
.dialog {
  height: 100%;
  width: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.dialog-bg {
  background: rgba(0, 0, 0, 1);
  opacity: 0.3;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1001;
}
.dialog-content {
  display: flex;
  margin: auto;
  width: 286px;
  height: 191px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  align-items: center;
  display: flex;
  flex-direction: column;
  z-index: 1002;
}
.dialog-btn {
  width: 90px;
  height: 40px;
  background: rgba(64, 64, 64, 1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 40px;
}
.dialog-content p:nth-child(1) {
  color: #28a3b1;
  border-radius: 16px;
  margin: 40px 0 20px;
}
.dialog-content p:nth-child(2) {
  font-size: 14px;
  color: rgba(33, 33, 33, 1);
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/modelReward.vue